const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLookBlockCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.99mm",
    height: "14.58mm",
    viewBox: "0 0 51 41.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,30.19l-2.57-6.95-6.95-2.57,6.95-2.57,2.57-6.95,2.57,6.95,6.95,2.57-6.95,2.57-2.57,6.95ZM19.6,20.67l4.31,1.59,1.59,4.31,1.59-4.31,4.31-1.59-4.31-1.59-1.59-4.31-1.59,4.31-4.31,1.59Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.27,
    y: 11.68,
    width: 3.17,
    height: 1.26,
    transform: "translate(1.21 27.54) rotate(-45)",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.73,14.9c-.39,0-.76-.15-1.04-.43-.28-.28-.43-.64-.43-1.04s.15-.76.43-1.04l2.24-2.24c.57-.57,1.5-.57,2.07,0,.28.28.43.64.43,1.04s-.15.76-.43,1.04l-2.24,2.24c-.28.28-.64.43-1.04.43ZM34.98,10.98c-.05,0-.11.02-.15.06l-2.24,2.24c-.05.05-.06.12-.06.15s0,.09.06.15c.11.11.19.11.3,0l2.24-2.24c.05-.05.06-.12.06-.15s0-.09-.06-.15c-.04-.04-.09-.06-.15-.06Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.56,
    y: 28.39,
    width: 3.17,
    height: 1.26,
    transform: "translate(-15.5 20.62) rotate(-45)",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.02,31.61c-.39,0-.76-.15-1.04-.43-.57-.57-.57-1.5,0-2.07l2.24-2.24c.57-.57,1.5-.57,2.07,0s.57,1.5,0,2.07l-2.24,2.24c-.28.28-.64.43-1.04.43ZM18.27,27.69c-.05,0-.11.02-.15.06l-2.24,2.24c-.08.08-.08.21,0,.3.11.11.19.11.3,0l2.24-2.24c.08-.08.08-.21,0-.3-.04-.04-.09-.06-.15-.06Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.52,
    y: 10.73,
    width: 1.26,
    height: 3.17,
    transform: "translate(-3.68 15.73) rotate(-45)",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.27,14.9c-.39,0-.76-.15-1.04-.43l-2.24-2.24c-.57-.57-.57-1.5,0-2.07.57-.57,1.5-.57,2.07,0l2.24,2.24c.57.57.57,1.5,0,2.07-.28.28-.64.43-1.04.43ZM16.02,10.98c-.05,0-.11.02-.15.06-.08.08-.08.21,0,.3l2.24,2.24c.11.11.19.11.3,0,.08-.08.08-.21,0-.3l-2.24-2.24s-.09-.06-.15-.06Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.23,
    y: 27.44,
    width: 1.26,
    height: 3.17,
    transform: "translate(-10.6 32.45) rotate(-45.01)",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.98,31.61c-.39,0-.76-.15-1.04-.43l-2.24-2.24c-.28-.28-.43-.64-.43-1.04s.15-.76.43-1.04c.57-.57,1.5-.57,2.07,0l2.24,2.24c.57.57.57,1.5,0,2.07-.28.28-.64.43-1.04.43ZM32.73,27.69c-.05,0-.11.02-.15.06-.08.08-.08.21,0,.3l2.24,2.24c.11.11.19.11.3,0,.08-.08.08-.21,0-.3l-2.24-2.24s-.09-.06-.15-.06Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.5 12.96 27.58 18.58 33.21 20.67 27.58 22.75 25.5 28.38 23.42 22.75 17.79 20.67 23.42 18.58 25.5 12.96",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.36,
    y: 20.04,
    width: 3.17,
    height: 1.26,
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.53,22.13h-3.17c-.81,0-1.47-.66-1.47-1.47s.66-1.47,1.47-1.47h3.17c.81,0,1.47.66,1.47,1.47s-.66,1.47-1.47,1.47ZM37.36,20.46c-.12,0-.21.09-.21.21s.09.21.21.21h3.17c.12,0,.21-.09.21-.21s-.09-.21-.21-.21h-3.17Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.47,
    y: 20.04,
    width: 3.17,
    height: 1.26,
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.64,22.13h-3.17c-.81,0-1.47-.66-1.47-1.47s.66-1.47,1.47-1.47h3.17c.81,0,1.47.66,1.47,1.47s-.66,1.47-1.47,1.47ZM10.47,20.46c-.12,0-.21.09-.21.21s.09.21.21.21h3.17c.12,0,.21-.09.21-.21s-.09-.21-.21-.21h-3.17Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.36,
    y1: 20.67,
    x2: 40.53,
    y2: 20.67,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.53,21.5h-3.17c-.46,0-.84-.37-.84-.84s.37-.84.84-.84h3.17c.46,0,.84.38.84.84s-.37.84-.84.84Z",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.47,
    y1: 20.67,
    x2: 13.64,
    y2: 20.67,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.64,21.5h-3.17c-.46,0-.84-.37-.84-.84s.37-.84.84-.84h3.17c.46,0,.84.38.84.84s-.37.84-.84.84Z",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.87,
    y: 32.53,
    width: 1.26,
    height: 3.17,
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.03,35.7v-3.17c0-.81.66-1.47,1.47-1.47s1.47.66,1.47,1.47v3.17c0,.81-.66,1.47-1.47,1.47s-1.47-.66-1.47-1.47ZM25.71,32.53c0-.12-.09-.21-.21-.21s-.21.09-.21.21v3.17c0,.12.09.21.21.21s.21-.09.21-.21v-3.17Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.87,
    y: 5.63,
    width: 1.26,
    height: 3.17,
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.03,8.81v-3.17c0-.81.66-1.47,1.47-1.47s1.47.66,1.47,1.47v3.17c0,.81-.66,1.47-1.47,1.47s-1.47-.66-1.47-1.47ZM25.71,5.63c0-.12-.09-.21-.21-.21s-.21.09-.21.21v3.17c0,.12.09.21.21.21s.21-.09.21-.21v-3.17Z",
    style: {
      fill: "#a86aad"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 32.53,
    x2: 25.5,
    y2: 35.7,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66,35.7v-3.17c0-.46.37-.84.84-.84s.84.37.84.84v3.17c0,.46-.38.84-.84.84s-.84-.37-.84-.84Z",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 5.63,
    x2: 25.5,
    y2: 8.81,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66,8.81v-3.17c0-.46.37-.84.84-.84s.84.37.84.84v3.17c0,.46-.38.84-.84.84s-.84-.37-.84-.84Z",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.73,
    y1: 13.43,
    x2: 34.98,
    y2: 11.19,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.73,14.27c-.21,0-.43-.08-.59-.25-.33-.33-.33-.86,0-1.18l2.24-2.24c.33-.33.86-.33,1.18,0s.33.86,0,1.18l-2.24,2.24c-.16.16-.38.25-.59.25Z",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.02,
    y1: 30.14,
    x2: 18.27,
    y2: 27.9,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.02,30.98c-.21,0-.43-.08-.59-.25-.33-.33-.33-.86,0-1.18l2.24-2.24c.33-.33.86-.33,1.18,0s.33.86,0,1.18l-2.24,2.24c-.16.16-.38.25-.59.25Z",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.27,
    y1: 13.43,
    x2: 16.02,
    y2: 11.19,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.27,14.27c-.21,0-.43-.08-.59-.25l-2.24-2.24c-.33-.33-.33-.86,0-1.18s.86-.33,1.18,0l2.24,2.24c.33.33.33.86,0,1.18-.16.16-.38.25-.59.25Z",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.98,
    y1: 30.14,
    x2: 32.73,
    y2: 27.9,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.98,30.98c-.21,0-.43-.08-.59-.25l-2.24-2.24c-.33-.33-.33-.86,0-1.18s.86-.33,1.18,0l2.24,2.24c.33.33.33.86,0,1.18-.16.16-.38.25-.59.25Z",
    style: {
      fill: "#34332b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookBlockCategory);
export default __webpack_public_path__ + "static/media/look_block_category.07e4fa155c22b465a032072df28ae1bb.svg";
export { ForwardRef as ReactComponent };